// src/Components/Descargas/openExternal.js
export async function openExternal(url) {
  try {
    // Solo en entorno nativo (Capacitor); evita romper el build web
    if (window?.Capacitor?.isNativePlatform) {
      const { Browser } = await import('@capacitor/browser');
      await Browser.open({ url });
      return;
    }
  } catch (e) {
    // si falla el import, caemos al fallback
    console.warn('Capacitor Browser no disponible, abriendo con window.open');
  }
  // Web fallback
  window.open(url, '_blank', 'noopener,noreferrer');
}
